// extracted by mini-css-extract-plugin
export var productionHolder = "Productions-module--productionHolder--852mW";
export var homePageProductionHolder = "Productions-module--homePageProductionHolder--dQcNY";
export var productionsFilterHolder = "Productions-module--productionsFilterHolder--PrT9A";